import { create } from "zustand";
import type { ToolsStore } from "./types";
import { fetchAppInfo, fetchHealthcheck } from "../../../api";
import { useMessageStore } from "../../store";
import { asyncActionWrapper } from "../utils/asyncActionWrapper";


export const useToolsStore = create<ToolsStore>((set, get) => ({
    loadingInfo: false,
    loadingGeneral: false,
    info: { app_version: "", database_migration: "", document_counts_db: 0, document_counts_index: 0, faqs_counts_db: 0, faqs_counts_index: 0 },
    healthCheck: { database: "", blob: "", document_intelligence: "", openai: "", speech_2_text: "" },
    chunks: [],
    asyncActionWrapper,
    fetchInfo: async () => {
        if (get().loadingInfo) return;
        set({ loadingInfo: true });
        try {
            set({ info: await fetchAppInfo() });
        } catch (error) {
            const message = `Could not load application information: ${error instanceof Error ? error.message : "Unknown error"}`;
            useMessageStore.getState().addError(message);
        } finally {
            set({ loadingInfo: false });
        }
    },
    fetchHealthCheck: async () => {
        if (get().loadingGeneral) return;
        set({ loadingGeneral: true });
        try {
            set({ healthCheck: await fetchHealthcheck() });
        } catch (error) {
            const message = `Could not run health check: ${error instanceof Error ? error.message : "Unknown error"}`;
            useMessageStore.getState().addError(message);
        } finally {
            set({ loadingGeneral: false });
        }
    },
    resetChunks: () => set({ chunks: [] }),
}));
